<script>
  export let idInterno;
  export let tipoEvaluacion;

  import HiddenInput from "../../components/HiddenInput.svelte";

  import { DOMAIN, post } from "../../js/api";
  import { getToken, getUsername } from "../../js/local";
  import {
    sanitizeString,
    sanitizeName,
    sanitizeNIF,
  } from "../../js/sanitizeString";

  import QrCode from "svelte-qrcode";

  import { navigate } from "svelte-routing";
  import { onMount } from "svelte";

  const ESTADO_TIMER = 20;
  let timer = ESTADO_TIMER;

  const token = getToken();

  const url = DOMAIN + idInterno;

  let surveyId = -1;

  let alumnosOnline = 0;
  let alumnosPresentes = 0;
  let cuestionariosRecibidos = 0;

  let profesor = "";
  let closeCode = "";

  let surveyClosed = false;

  let showCloseCode = false;

  let nombreAlumno = "";
  let nombreResponsable = "";
  let nombreProfesor = "";
  let DNIAlumno = "";
  let DNIResponsable = "";
  let DNIProfesor = "";
  let incidencias = "";

  let errorNombreAlumno = false;
  let errorNombreResponsable = false;
  let errorNombreProfesor = false;
  let errorDNIAlumno = false;
  let errorDNIResponsable = false;
  let errorDNIProfesor = false;

  let shownCloseCodeMsg = false;

  let myUsername = getUsername();

  let loading = true;

  let visibleWindow = true;

  $: if (nombreAlumno && nombreAlumno !== "") {
    nombreAlumno = sanitizeName(nombreAlumno);
  }

  $: if (nombreResponsable && nombreResponsable !== "") {
    nombreResponsable = sanitizeName(nombreResponsable);
  }

  $: if (nombreProfesor && nombreProfesor !== "") {
    nombreProfesor = sanitizeName(nombreProfesor);
  }

  $: if (DNIAlumno && DNIAlumno !== "") {
    DNIAlumno = sanitizeNIF(DNIAlumno);
  }

  $: if (DNIResponsable && DNIResponsable !== "") {
    DNIResponsable = sanitizeNIF(DNIResponsable);
  }

  $: if (DNIProfesor && DNIProfesor !== "") {
    DNIProfesor = sanitizeNIF(DNIProfesor);
  }

  $: if (incidencias && incidencias !== "") {
    incidencias = sanitizeString(incidencias);
  }

  onMount(() => {
    getEvaluacion();

    document.addEventListener("visibilitychange", function () {
      visibleWindow = !document.hidden;
      //console.log(document.hidden);
    });
  });

  let getEvaluacion = async () => {
    const response = await post("RecibirEvaluacionResp", {
      token,
      idInterno,
      tipoEvaluacion,
    });

    let evaluador = response.evaluador;
    if (myUsername !== "" && evaluador === myUsername) {
      profesor = response.profesor + " - " + response.asignatura;
      surveyId = response.id;
      closeCode = response.codigoCierre;

      loading = false;

      getEstadoEvaluacion(false);
    } else {
      navigate("/" + idInterno, { replace: true });
    }
  };

  let getEstadoEvaluacion = async (forced) => {
    //console.log(timer);
    if (!surveyClosed) {
      if (visibleWindow) {
        /*const response = await post("EstadoEvaluacion", {
          token,
          idEvaluacion: surveyId,
          tipoEvaluacion,
        });

        alumnosOnline = response.numOnline;
        cuestionariosRecibidos = response.numRecibidos;*/
        timer--;
        if (timer <= 0 || forced) {
          const response = await post("EstadoEvaluacion", {
            token,
            idEvaluacion: surveyId,
            tipoEvaluacion,
          });

          alumnosOnline = response.numOnline;
          cuestionariosRecibidos = response.numRecibidos;

          timer = ESTADO_TIMER;
        }
      }

      /*if (!forced) {
        setTimeout(() => getEstadoEvaluacion(false), ESTADO_TIMER);
      }*/
    }

    if (!forced) {
      setTimeout(() => getEstadoEvaluacion(false), 1000);
    }
  };

  let restartEvaluacion = async () => {
    await post("ReiniciarEvaluacion", {
      token,
      idEvaluacion: surveyId,
      tipoEvaluacion,
    });

    surveyClosed = true;

    navigate("/inicio", { replace: true });
  };

  let closeEvaluacion = async () => {
    await post("FinalizarEvaluacion", {
      token,
      idEvaluacion: surveyId,
      tipoEvaluacion,
    });

    surveyClosed = true;
  };

  let codeEvaluacion = async () => {
    await post("CodigoEvaluacion", {
      token,
      idEvaluacion: surveyId,
      tipoEvaluacion,
    });
  };

  let sendEvaluacion = async () => {
    errorNombreAlumno = nombreAlumno.trim() === "";
    errorNombreProfesor = nombreProfesor.trim() === "";
    errorNombreResponsable = nombreResponsable.trim() === "";
    errorDNIAlumno = DNIAlumno.trim() === "";
    errorDNIProfesor = DNIProfesor.trim() === "";
    errorDNIResponsable = DNIResponsable.trim() === "";
    if (
      !errorNombreAlumno &&
      !errorNombreProfesor &&
      !errorNombreResponsable &&
      !errorDNIAlumno &&
      !errorDNIProfesor &&
      !errorDNIResponsable
    ) {
      await post("ActualizarAlumnosPresentes", {
        token,
        idEvaluacion: surveyId,
        numPresentes: alumnosPresentes,
        tipoEvaluacion,
      });

      await post("CerrarEvaluacion", {
        token,
        idEvaluacion: surveyId,
        alumno: nombreAlumno,
        docente: nombreProfesor,
        responsable: nombreResponsable,
        DNIAlumno,
        DNIDocente: DNIProfesor,
        DNIResponsable,
        incidencias,
        tipoEvaluacion,
      });

      navigate("/cuestionario-gracias-resp", { replace: true });
    }
  };

  let checkAlumnosPresentes = () => {
    alumnosPresentes = alumnosPresentes.replace(/[^\d]/g, "");
  };

  $: if (alumnosPresentes) {
    checkAlumnosPresentes();
  }
</script>

{#if !loading}
  <div class="screen">
    {#if !surveyClosed}
      <div class="screenheader">
        <div class="headertitle">
          <div class="headersteptxt stepnumbercompleted">1</div>
          <div class="separadorpasos" />
          <div class="headersteptxt lastitem">2</div>
          <div class="headertitletxt">
            <strong class="textbold">Acceda</strong> al cuestionario
          </div>
        </div>
        <img
          src="/images/logo-uex-white.png"
          loading="lazy"
          width="80"
          sizes="(max-width: 479px) 60px, (max-width: 767px) 55px, (max-width: 991px) 65px, 80px"
          srcset="/images/logo-uex-white-p-500.png 500w, /images/logo-uex-white.png 780w"
          alt=""
          class="logoheader"
        />
      </div>
      <div class="screenbody">
        <div class="urlstyletext">{url}</div>
        <div class="profesor">{profesor}</div>
        <div class="qrimg">
          <QrCode value={url} size={360} />
        </div>
        <div class="blockitem">
          <div class="trackingitem">
            <div class="trackingnumber">{alumnosOnline}</div>
            <div class="textstyle strongstyle">alumnos/as conectado/as</div>
          </div>
          <div class="trackingitem">
            <div class="trackingnumber">
              <input type="text" bind:value={alumnosPresentes} />
            </div>
            <div class="textstyle strongstyle">alumnos/as presentes</div>
            <img
              class="editNumAlumnos"
              src="/images/edit-num.svg"
              alt="Edit Num Alumnos Presentes"
            />
          </div>
          <div class="trackingitem lasitem">
            <div class="trackingnumber">{cuestionariosRecibidos}</div>
            <div class="textstyle strongstyle">cuestionarios recibidos</div>
          </div>
          <div class="refreshSection">
            <div class="proximoRefresco">Próxima comprobación en {timer} s</div>
            <div class="refresh">
              <img
                src="/images/refresh.svg"
                alt="Refresh Button"
                on:click={() => getEstadoEvaluacion(true)}
              />
            </div>
          </div>
        </div>
        <div class="linecontainer">
          {#if showCloseCode}
            <span
              class="code"
              on:click={() => {
                showCloseCode = false;
              }}>{closeCode}</span
            >
          {:else}
            <div class="textstyle strongstyle">Código de cierre OCULTO</div>
            <img
              src="/images/view.svg"
              loading="lazy"
              width="30"
              height="30"
              alt=""
              class="blockitem smallblockitem eye"
              on:click={async () => {
                if (!shownCloseCodeMsg) {
                  if (
                    window.confirm(
                      "Si muestra el código no podrán acceder más alumnos al cuestionario. ¿Desea continuar?"
                    )
                  ) {
                    showCloseCode = true;
                    shownCloseCodeMsg = true;
                    codeEvaluacion();
                  }
                } else {
                  showCloseCode = !showCloseCode;
                }
              }}
            />
          {/if}
        </div>
        <div class="buttonscontainer">
          <div
            class="greybuttonstyle buttonrightmargin w-button"
            on:click={() => {
              if (
                window.confirm(
                  "Si reinicia el cuestionario se generará uno nuevo y toda la información, incluyendo evaluaciones ya enviadas, se perderán. ¿Desea continuar?"
                )
              ) {
                restartEvaluacion();
              }
            }}
          >
            Reiniciar cuestionario
          </div>
          <div
            class="{alumnosPresentes > 0 && cuestionariosRecibidos > 0
              ? 'greenbuttonstyle'
              : 'greybuttonstyle'} nomargin w-button"
            on:click={() => {
              if (alumnosPresentes <= 0) {
                alert(
                  "Debe escribir el número de alumnos presentes en el aula."
                );
              } else {
                if (cuestionariosRecibidos <= 0) {
                  alert("No se han recibido cuestionarios de alumnos.");
                } else {
                  if (
                    window.confirm(
                      "Va a cerrar el cuestionario y ya no se podrá enviar más evaluaciones. ¿Desea continuar?"
                    )
                  ) {
                    closeEvaluacion();
                  }
                }
              }
            }}
          >
            Cerrar cuestionario
          </div>
        </div>
      </div>
    {:else}
      <div class="screenheader">
        <div class="headertitle">
          <div class="headersteptxt stepnumbercompleted">1</div>
          <div class="separadorpasos" />
          <div class="headersteptxt stepnumbercompleted">2</div>
          <div class="separadorpasos" />
          <div class="headersteptxt lastitem">3</div>
          <div class="headertitletxt">
            <strong class="textbold">Finalizar</strong> cuestionario
          </div>
        </div>
        <img
          src="/images/logo-uex-white.png"
          loading="lazy"
          width="80"
          sizes="(max-width: 479px) 13vw, (max-width: 767px) 55px, (max-width: 991px) 8vw, (max-width: 1919px) 7vw, 4vw"
          srcset="/images/logo-uex-white-p-500.png 500w, /images/logo-uex-white.png 780w"
          alt=""
          class="logoheader"
        />
      </div>
      <div class="screenbody">
        <div class="textstyle titlestyle rgpd">
          En cumplimiento del RGPD y la LOPDgdd, se comunica que la Universidad
          de Extremadura es Responsable del tratamiento de datos personales
          denominado ESEAD. Este tratamiento se realiza en cumplimiento de la
          legislación vigente. Los datos no serán comunicados. Tiene derecho a
          acceder, rectificar y suprimir los datos personales, así como a
          ejercer el resto de derechos, escribiendo un correo electrónico a la
          dirección: utec@unex.es. Caso de que su reclamación no sea atendida
          puede dirigirse al Delegado de Protección de Datos (dpd@unex.es) y
          posteriormente a la Agencia Española de Protección de Datos
          (www.aepd.es). Acepto la condiciones y confirmo que he leído la
          Política de Privacidad.
        </div>
        <div class="blockitem blockitemEnd">
          <div class="trackingitem lasitem">
            <div class="trackingnumber">{cuestionariosRecibidos}</div>
            <div class="textstyle strongstyle">cuestionarios recibidos</div>
          </div>
        </div>
        <div class="textstyle dataprivacytest">
          ‍<strong
            class="comboboxstyle paragraphstyle firstitem {errorNombreAlumno
              ? 'error'
              : ''}"
            ><input
              type="text"
              maxlength="150"
              bind:value={nombreAlumno}
            /></strong
          >, DNI
          <HiddenInput
            bind:text={DNIAlumno}
            length="15"
            error={errorDNIAlumno}
          />, alumno de la asignatura impartida por el docente objeto de
          evaluación, está conforme con el acto de realización del cuestionario.<br
          />‍<br /><strong
            class="comboboxstyle paragraphstyle {errorNombreProfesor
              ? 'error'
              : ''}"
            ><input
              type="text"
              maxlength="150"
              bind:value={nombreProfesor}
            /></strong
          >, DNI
          <HiddenInput
            bind:text={DNIProfesor}
            length="15"
            error={errorDNIProfesor}
          />, docente de la asignatura presente en el aula, está conforme con el
          acto de realización del cuestionario.<br /><br /><strong
            class="comboboxstyle paragraphstyle {errorNombreResponsable
              ? 'error'
              : ''}"
            ><input
              type="text"
              maxlength="150"
              bind:value={nombreResponsable}
            /></strong
          >, DNI
          <HiddenInput
            bind:text={DNIResponsable}
            length="15"
            error={errorDNIResponsable}
          />, responsable de evaluación, está conforme con el acto de
          realización del cuestionario.
          <br /><span class="textstyle strongstyle incidencias"
            >Incidencias</span
          >
          <textarea bind:value={incidencias} maxlength="500" />
        </div>
        <div
          class="greenbuttonstyle w-button"
          on:click={() => sendEvaluacion()}
        >
          Finalizar y Enviar
        </div>
      </div>
    {/if}
    <div class="screenfooter">
      <img
        src="/images/logo-uex-complete-black.png"
        loading="lazy"
        width="300"
        sizes="(max-width: 479px) 83vw, 250px"
        srcset="/images/logo-uex-complete-black-p-500.png 500w, /images/logo-uex-complete-black-p-800.png 800w, /images/logo-uex-complete-black-p-1080.png 1080w, /images/logo-uex-complete-black-p-1600.png 1600w, /images/logo-uex-complete-black-p-2000.png 2000w, /images/logo-uex-complete-black-p-2600.png 2600w, /images/logo-uex-complete-black-p-3200.png 3200w, /images/logo-uex-complete-black.png 3994w"
        alt=""
        class="logobottom"
      />
    </div>
  </div>
{/if}

<style>
  div.refresh {
    display: flex;
    justify-content: center;
  }

  div.refresh img {
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin-left: 12px;
  }

  div.profesor {
    color: #000;
    font-weight: 700;
    letter-spacing: 0px;
    font-size: 18px;
    margin-top: 40px;
  }

  input {
    width: 100%;
    height: 100%;
    margin: 0px;
    background: transparent;
    padding: 0px;
    border: 0px;
    text-align: center;
  }

  span.code {
    cursor: pointer;
    color: #000;
    font-weight: 700;
    letter-spacing: 0px;
    font-size: 40px;
  }

  img.eye {
    cursor: pointer;
  }

  strong {
    padding: 5px;
  }

  strong.comboboxstyle {
    padding: 5px;
    background-color: #ededed !important;
  }

  strong.error {
    border: 1px solid red;
  }

  img.editNumAlumnos {
    height: 15px;
  }

  div.blockitemEnd {
    margin-top: 0px !important;
    margin-bottom: 30px;
  }

  div.dataprivacytest {
    margin-bottom: 50px;
  }

  div.rgpd {
    text-align: justify;
  }

  textarea {
    background-color: #ededed;
    line-height: 24px;
    font-weight: 600;
    letter-spacing: 0.2px;
    border: 3px solid transparent;
    border-radius: 2px;
    box-shadow: 1px 1px 3px 0 #e6e6e6;
    font-family: "Open Sans", sans-serif;
    color: #737373;
    width: 100%;
  }

  span.incidencias {
    margin-top: 10px;
    margin-bottom: 5px;
  }

  div.refreshSection {
    display: flex;
    align-items: center;
    margin-top: 15px;
    font-size: 12px;
    font-weight: bold;
  }

  @media screen and (max-width: 479px) {
    .greybuttonstyle {
      margin-left: 0px;
      margin-right: 0px;
    }
  }
</style>
